import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 14.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16 14.7H0L8.1 0zm-14.3-1h12.6L8.1 2zM8.5 12H7.4v-1.1h1.1zm.1-2.1H7.5V5.8h1.1z" />
  </svg>
);
const SvgExclamationTriangle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="exclamation-triangle" {...props} />;
export default SvgExclamationTriangle;
